//https://github.com/alex-cory/react-useportal

import styled from "@emotion/styled";
import { usePortal } from "@hooks";

const DropdownDiv = styled.div`
  /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding: 20px;
  display: flex;
  flex-direction: column;
  z-index: 1300; */
`;

const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  position: fixed;
  touch-action: none;
  backdrop-filter: none;
  background-color: transparent;
  opacity: 0;
`;

export const useDropdown = ({ width, height, onOpen, ...config }: any = {}) => {
  const {
    isOpen,
    togglePortal,
    Portal,
    ref: targetRef,
    portalRef,
    closePortal,
  } = usePortal({
    onOpen(args: any) {
      const { portal, targetEl } = args;
      const clickedEl = targetEl.current;

      const { top, bottom, left, right } = clickedEl.getBoundingClientRect();

      let l = left;
      let t = top + clickedEl.clientHeight;
      const outRight = window.innerWidth < left + clickedEl.offsetWidth;
      const outBottom = window.innerHeight < top + portal.current.clientHeight;
      const outTop = false;
      const outLeft = false;
      if (outRight) {
        l = window.innerWidth - (right - left + clickedEl.offsetWidth);
      } else if (outLeft) {
        /* very uncommon, implement later */
      }
      if (outBottom) {
        t = window.innerHeight - (bottom - top + height);
      } else if (outTop) {
        /* very uncommon, implement later */
      }
      portal.current.style.cssText = `
        
        position: absolute;
        top: ${t + 2}px;
        right: ${window.innerWidth - right}px;
        background: #ffff;
        z-index: 10;
			`;
      if (onOpen) onOpen(args);
    },
    onScroll({ portal }: any) {
      console.log("SCROLLING");
      // TODO: add logic so when scrolling, the portal doesn't get displaced
    },
    onResize() {
      // TODO: need to implement for when it's outside of viewport
    },
    closeOnOutsideClick: false, //in some cases it doesn't work properly
    ...config,
  });
  return {
    Dropdown: (props: any) => (
      <Portal>
        <Overlay onClick={closePortal} />
        <DropdownDiv {...props} />
      </Portal>
    ),
    toggleDropdown: togglePortal,
    isOpen,
  };
};
